//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  signal,
  WritableSignal,
} from "@angular/core";

//local imports
import { PresenterRegistration } from "@app/shared";
import { AbstractRoomModel, RoomDisplayMode } from "@app/catalog-common";

@PresenterRegistration({
   types: [AbstractRoomModel],
   key:"breadcrumb-item",
})
@Component({
  selector: "room-breadcrumb-presenter",
  template: '<room-item [id]="data().id" [room]="data()" [displayMode]="DisplayMode.Code" />',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RoomBreadcrumbPresenterComponent {
  DisplayMode: typeof RoomDisplayMode = RoomDisplayMode;

  public data: WritableSignal<AbstractRoomModel>;

  constructor() {
    this.data = signal<AbstractRoomModel>(null);
  }
}
